// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VKm4vCVbxG9p1C6TkRu4{padding:25px 0 32px 0}.kgMNpLiZLAMJJsn3g6e7{display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-bottom:12px}.T2RgQ4eIkxGgztCQbKBA{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBar": "VKm4vCVbxG9p1C6TkRu4",
	"progressBarTitleContainer": "kgMNpLiZLAMJJsn3g6e7",
	"progressBarSteps": "T2RgQ4eIkxGgztCQbKBA"
};
export default ___CSS_LOADER_EXPORT___;
